const fieldConfig = {
  antecedentes: [
    { name: "cirugias", label: "Cirugías", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "tabaco", label: "Tabaco", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "alcohol", label: "Alcohol", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "drogas", label: "Drogas", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "act_fisica", label: "Actividad Física", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "alergia", label: "Alergia", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "diabetes_t1", label: "Diabetes Tipo 1", type: "checkbox" },
    { name: "diabetes_t2", label: "Diabetes Tipo 2", type: "checkbox" },
    { name: "hiper_arterial", label: "Hipertensión Arterial", type: "checkbox" },
    { name: "asma", label: "Asma", type: "checkbox" },
    { name: "insuf_card", label: "Insuficiencia Cardíaca", type: "checkbox" },
    { name: "insuf_resp", label: "Insuficiencia Respiratoria", type: "checkbox" },
    { name: "sincope_mareos", label: "Síncope/Mareos", type: "checkbox" },
    { name: "epilepsia", label: "Epilepsia", type: "checkbox" }
  ],
  antropometrico: [
    { name: "peso", label: "Peso (kg)", type: "number" },
    { name: "talla", label: "Talla (cm)", type: "number" },
    { name: "imc", label: "IMC", type: "number" },
    { name: "presion_sistolica", label: "Presión Sistólica (mmHg)", type: "number" },
    { name: "presion_diastolica", label: "Presión Diastólica (mmHg)", type: "number" },
    { name: "frec_cardiaca", label: "Frecuencia Cardíaca (bpm)", type: "number" },
    { name: "cintura", label: "Cintura (cm)", type: "number" },
    { name: "glicemia", label: "Glicemia (mg/dL)", type: "number" }
  ],
  audiometria: [
    { name: "od500", label: "OD 500 Hz", type: "number" },
    { name: "od1000", label: "OD 1000 Hz", type: "number" },
    { name: "od2000", label: "OD 2000 Hz", type: "number" },
    { name: "od3000", label: "OD 3000 Hz", type: "number" },
    { name: "od4000", label: "OD 4000 Hz", type: "number" },
    { name: "od6000", label: "OD 6000 Hz", type: "number" },
    { name: "od8000", label: "OD 8000 Hz", type: "number" },
    { name: "oi500", label: "OI 500 Hz", type: "number" },
    { name: "oi1000", label: "OI 1000 Hz", type: "number" },
    { name: "oi2000", label: "OI 2000 Hz", type: "number" },
    { name: "oi3000", label: "OI 3000 Hz", type: "number" },
    { name: "oi4000", label: "OI 4000 Hz", type: "number" },
    { name: "oi6000", label: "OI 6000 Hz", type: "number" },
    { name: "oi8000", label: "OI 8000 Hz", type: "number" }
  ],
  cultivo: [
    { name: "coprocultivo", label: "Coprocultivo", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "nasofaringeo", label: "Nasofaríngeo", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "lecho_ungueal", label: "Lecho Ungueal", type: "select", options: ["positivo", "negativo", "no aplica"] }
  ],
  droga: [
    { name: "marihuana", label: "Marihuana", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "cocaina", label: "Cocaína", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "anfetamina", label: "Anfetamina", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "benzodiacepinas", label: "Benzodiacepinas", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "opiaceos", label: "Opiáceos", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "alcohol_s", label: "Alcohol en Sangre", type: "select", options: ["positivo", "negativo", "no aplica"] },
    { name: "metanfetaminas", label: "Metanfetaminas", type: "select", options: ["positivo", "negativo", "no aplica"] }
  ],
  fisico: [
    { name: "cabeza_cuello", label: "Cabeza y Cuello", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "cabeza_cuello_txt", label: "Observaciones Cabeza y Cuello", type: "text" },
    { name: "cardiaco", label: "Cardíaco", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "cardiaco_txt", label: "Observaciones Cardíaco", type: "text" },
    { name: "pulmonar", label: "Pulmonar", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "pulmonar_txt", label: "Observaciones Pulmonar", type: "text" },
    { name: "abdomen", label: "Abdomen", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "abdomen_txt", label: "Observaciones Abdomen", type: "text" },
    { name: "ext_sup", label: "Extremidades Superiores", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "ext_sup_txt", label: "Observaciones Extremidades Superiores", type: "text" },
    { name: "ext_inf", label: "Extremidades Inferiores", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "ext_inf_txt", label: "Observaciones Extremidades Inferiores", type: "text" }
  ],
  respiratorio: [
    { name: "fvc", label: "FVC (litros)", type: "number" },
    { name: "vef", label: "VEF (litros)", type: "number" },
    { name: "vef1", label: "VEF1 (litros)", type: "number" },
    { name: "encuesta", label: "Encuesta", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "encuesta_txt", label: "Observaciones Encuesta", type: "text" }
  ],
  sangre: [
    { name: "hemoglobina", label: "Hemoglobina (g/dL)", type: "number" },
    { name: "hematocrito", label: "Hematocrito (%)", type: "number" },
    { name: "plaquetas", label: "Plaquetas (10^9/L)", type: "number" },
    { name: "eritrocito", label: "Eritrocitos (mill/mm³)", type: "number" },
    { name: "leucocito", label: "Leucocitos (mill/mm³)", type: "number" },
    { name: "vhs", label: "VHS (mm/h)", type: "number" },
    { name: "creatinemia", label: "Creatinemia (mg/dL)", type: "number" },
    { name: "uremia", label: "Uremia (mg/dL)", type: "number" },
    { name: "colinesterasa", label: "Colinesterasa (U/L)", type: "number" },
    { name: "transaminasa_got", label: "Transaminasa GOT (U/L)", type: "number" },
    { name: "transaminasa_gpt", label: "Transaminasa GPT (U/L)", type: "number" },
    { name: "perfil_hepatico", label: "Perfil Hepático", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "colesterol_tot", label: "Colesterol Total (mg/dL)", type: "number" },
    { name: "hdl", label: "HDL (mg/dL)", type: "number" },
    { name: "trigliceridos", label: "Triglicéridos (mg/dL)", type: "number" },
    { name: "ldl", label: "LDL (mg/dL)", type: "number" }
  ],
  sensotecnico: [
    { name: "reactimetro_val", label: "Reactímetro Valor", type: "number" },
    { name: "reactimetro_res", label: "Reactímetro Resultado", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "punteo_aciertos", label: "Punteo Aciertos", type: "number" },
    { name: "punteo_err", label: "Punteo Errores", type: "number" },
    { name: "punteo_permanencia", label: "Punteo Permanencia", type: "number" },
    { name: "punteo_res", label: "Punteo Resultado", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "palanca_aciertos", label: "Palanca Aciertos", type: "number" },
    { name: "palanca_err", label: "Palanca Errores", type: "number" },
    { name: "palanca_permanencia", label: "Palanca Permanencia", type: "number" },
    { name: "palanca_res", label: "Palanca Resultado", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "vel_anticipacion_d", label: "Velocidad Anticipación Distancia", type: "number" },
    { name: "vel_anticipacion_t", label: "Velocidad Anticipación Tiempo", type: "number" },
    { name: "mono_err", label: "Mono Errores", type: "number" },
    { name: "mono_tpo_acierto", label: "Mono Tiempo Acierto", type: "number" },
    { name: "coord_bimanual", label: "Coordinación Bimanual", type: "number" },
    { name: "coord_bimanual_tpo", label: "Coordinación Bimanual Tiempo", type: "number" },
    { name: "reacc_mult", label: "Reacción Múltiple", type: "number" },
    { name: "reacc_mult_tpo", label: "Reacción Múltiple Tiempo", type: "number" }
  ],
  vista: [
    { name: "lentes_cerca", label: "Usa Lentes de Cerca", type: "checkbox" },
    { name: "lentes_lejos", label: "Usa Lentes de Lejos", type: "checkbox" },

    { name: "ojo_izq_cerca", label: "Ojo Izquierdo Cerca", type: "number" },
    { name: "ojo_izq_lejos", label: "Ojo Izquierdo Lejos", type: "number" },
    { name: "ojo_der_cerca", label: "Ojo Derecho Cerca", type: "number" },
    { name: "ojo_der_lejos", label: "Ojo Derecho Lejos", type: "number" },

    { name: "profundidad", label: "Profundidad", type: "number" },
    { name: "foria_vert", label: "Foria Vertical", type: "number" },
    { name: "foria_hor", label: "Foria Horizontal", type: "number" },
    { name: "colores", label: "Colores", type: "number" },
    { name: "ishiara", label: "Ishiara", type: "number" },

    { name: "noche", label: "Vista Nocturna", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "encandilamiento", label: "Encandilamiento", type: "select", options: ["normal", "alterado", "no aplica"] },
    { name: "perimetria", label: "Perimetría", type: "select", options: ["normal", "alterado", "no aplica"] },

    { name: "recuperacion_encandilamiento", label: "Recuperación Encandilamiento (segundos)", type: "number" }
  ],
  ecg_reposo: [
    { name: "comentarios", label: "Comentarios", type: "string" }
  ],
  columna: [],
  equilibrio: [],
  agente_asma: []

};

export const EXAMENES_SOLO_CONCLUSION = ["columna", "equilibrio", "agente_asma"];

export default fieldConfig;